import { useMemo } from "react";
import BasicButton from "../../components/BasicButton";
import BasicModal from "../../components/BasicModal";
import useLogin from "./useLogin";
import { useTranslation } from "react-i18next";
import BasicInput from "../../components/BasicInput";
import { stdObject } from "../../data/types/stdObject";
import cats18 from "../../assets/18cats.svg";

const FALLING_ICONS_COUNT = 20;
const MIN_SIZE = 16;
const MAX_SIZE = 100;
const MIN_DURATION = 18;
const MAX_DURATION = 34;

export default function Login({
  isLoading,
  msgType,
  loginPack,
  logoutAction,
}: {
  isLoading: boolean;
  msgType: string;
  loginPack: stdObject;
  logoutAction: () => void;
}) {
  const { t } = useTranslation();

  const fallingIcons = useMemo(
    () =>
      Array.from({ length: FALLING_ICONS_COUNT }, (_, index) => {
        const size = MIN_SIZE + Math.random() * (MAX_SIZE - MIN_SIZE);
        const sizeRatio = (size - MIN_SIZE) / (MAX_SIZE - MIN_SIZE);
        const duration =
          MIN_DURATION + Math.random() * (MAX_DURATION - MIN_DURATION);
        return {
          key: index,
          size,
          left: Math.random() * 100,
          opacity: 0.08 + sizeRatio * 0.32,
          duration,
          delay: -Math.random() * duration,
        };
      }),
    [],
  );

  const {
    loginData,
    updateData,
    handleLogin,
    fields,
    msg,
    msg2,
    msgData,
    closeMsg,
    logoSrc,
    fallingImgSrc,
  } = useLogin({
    isLoading,
    msgType,
    loginPack,
    logoutAction,
  });

  return (
    <div className="mainBox">
      {fallingImgSrc !== "" && (
        <div className="fallingIconsBox">
          {fallingIcons.map((icon) => (
            <img
              key={icon.key}
              src={fallingImgSrc}
              alt=""
              className="fallingIcon"
              style={{
                left: `${icon.left}%`,
                width: icon.size,
                height: icon.size,
                opacity: icon.opacity,
                animationDuration: `${icon.duration}s`,
                animationDelay: `${icon.delay}s`,
              }}
            />
          ))}
        </div>
      )}
      <div className="loginBox">
        {logoSrc !== "" && (
          <div style={{ marginBottom: 10 }}>
            <img src={logoSrc} alt={"logo"} />
          </div>
        )}
        {fields.map((e, index) => (
          <BasicInput
            key={index}
            type={e === "username" ? "text" : e}
            label={t(`p.${e}`)}
            value={loginData[e as keyof typeof loginData]}
            onChange={(v) => {
              updateData(e, v.target.value);
              return {};
            }}
            onKeyDown={(v) => {
              if (v.keyCode === 13 && index) handleLogin();
              return {};
            }}
          />
        ))}
        <BasicButton
          title={t("p.enter")}
          onClick={handleLogin}
          style={{ marginTop: 10 }}
        />
        <div style={{ marginTop: 20 }}>
          <img src={cats18} alt={"logo"} />
        </div>
      </div>
      {msg !== "" && (
        <BasicModal
          open={msg !== ""}
          close={closeMsg}
          data={msg in msgData ? msgData[msg as keyof typeof msgData] : {}}
        />
      )}
      {msg2 !== "" && (
        <BasicModal
          open={msg2 !== ""}
          close={() => closeMsg(2)}
          data={msg2 in msgData ? msgData[msg2 as keyof typeof msgData] : {}}
        />
      )}
    </div>
  );
}
